/**
 * Convert PDF coordinates to screen coordinates.
 * PDF: origin at bottom-left, units in points.
 * Screen: origin at top-left, units in pixels.
 * At react-pdf scale=1, 1 PDF point ≈ 1 CSS pixel.
 */
export function pdfToScreen(
  pdfX: number,
  pdfY: number,
  pdfWidth: number,
  pdfHeight: number,
  pageHeight: number,
  scale: number
) {
  return {
    x: pdfX * scale,
    y: (pageHeight - pdfY - pdfHeight) * scale,
    width: pdfWidth * scale,
    height: pdfHeight * scale,
  };
}

/**
 * Convert screen coordinates to PDF coordinates.
 */
export function screenToPdf(
  screenX: number,
  screenY: number,
  screenWidth: number,
  screenHeight: number,
  pageHeight: number,
  scale: number
) {
  const pdfWidth = screenWidth / scale;
  const pdfHeight = screenHeight / scale;
  return {
    x: screenX / scale,
    y: pageHeight - screenY / scale - pdfHeight,
    width: pdfWidth,
    height: pdfHeight,
  };
}
